var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 3.4C5.45912 3.4 3.4001 5.46081 3.4001 8C3.4001 10.5392 5.45912 12.6 8.0001 12.6C10.5412 12.6 12.6001 10.5411 12.6001 8C12.6001 5.45891 10.5412 3.4 8.0001 3.4ZM2.6001 8C2.6001 5.01919 5.01708 2.6 8.0001 2.6C10.983 2.6 13.4001 5.01708 13.4001 8C13.4001 10.9829 10.983 13.4 8.0001 13.4C5.01708 13.4 2.6001 10.9808 2.6001 8ZM5.9321 7.288C5.9321 7.06708 6.11118 6.888 6.3321 6.888H6.3381C6.55901 6.888 6.7381 7.06708 6.7381 7.288C6.7381 7.50891 6.55901 7.688 6.3381 7.688H6.3321C6.11118 7.688 5.9321 7.50891 5.9321 7.288ZM9.2661 7.288C9.2661 7.06708 9.44518 6.888 9.6661 6.888H9.6721C9.89301 6.888 10.0721 7.06708 10.0721 7.288C10.0721 7.50891 9.89301 7.688 9.6721 7.688H9.6661C9.44518 7.688 9.2661 7.50891 9.2661 7.288Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00811 8.32023C3.05217 8.10375 3.26338 7.96398 3.47985 8.00804L5.87985 8.49649C6.0662 8.53442 6.20008 8.69829 6.20008 8.88845V10.3555C6.20008 10.4713 6.14992 10.5814 6.06257 10.6574L4.86157 11.7018C4.69488 11.8468 4.44222 11.8292 4.29725 11.6625C4.15229 11.4958 4.1699 11.2431 4.3366 11.0982L5.40008 10.1733V9.21525L3.32031 8.79197C3.10383 8.74791 2.96406 8.5367 3.00811 8.32023Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.991 8.31519C13.0378 8.53108 12.9008 8.74406 12.6849 8.7909L10.6 9.24324V10.3102L11.6741 11.3068C11.8361 11.457 11.8455 11.7101 11.6953 11.8721C11.545 12.034 11.2919 12.0435 11.13 11.8932L9.92798 10.7779C9.84641 10.7022 9.80005 10.596 9.80005 10.4847V8.92072C9.80005 8.73248 9.93128 8.56972 10.1152 8.52981L12.5152 8.00909C12.7311 7.96225 12.9441 8.0993 12.991 8.31519Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9999 8.6H5.7999C5.57899 8.6 5.3999 8.77908 5.3999 9V10.6C5.3999 10.8209 5.57899 11 5.7999 11H9.9999C10.2208 11 10.3999 10.8209 10.3999 10.6V9C10.3999 8.77908 10.2208 8.6 9.9999 8.6Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28497 5.02716C6.44118 5.18337 6.44118 5.43664 6.28497 5.59285L5.61497 6.26285C5.45876 6.41906 5.2055 6.41906 5.04929 6.26285C4.89308 6.10664 4.89308 5.85337 5.04929 5.69716L5.71929 5.02716C5.8755 4.87095 6.12876 4.87095 6.28497 5.02716Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.82364 5.02674C9.98008 4.87076 10.2333 4.87114 10.3893 5.02758L11.0573 5.69758C11.2133 5.85403 11.2129 6.10729 11.0565 6.26327C10.9 6.41924 10.6468 6.41887 10.4908 6.26242L9.82279 5.59242C9.66681 5.43598 9.66719 5.18271 9.82364 5.02674Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSick);
export default __webpack_public_path__ + "static/media/sick.fbacb1222b19396bf6f5d21a2f6e6277.svg";
export { ForwardRef as ReactComponent };